import React, { useEffect, useState } from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from "@material-ui/core";
import * as auth from "../../store/ducks/auth.duck";
import { getAppSystem } from "../../services/systemService";
import { connect } from "react-redux";
import { Image } from "react-bootstrap";
import { SelectButton } from "primereact/selectbutton";
import BootstrapTooltip from "../../partials/content/BootstrapTooltip";
import { PageSubHeader } from "../../../provider/PageDataProvider";
import { saveUserPreferences } from "../../services/usersService";
import { useGlobalData } from "../../../provider/GlobalDataProvider";

function Menu({ history }) {
  const { userPreferences, reload, setReload } = useGlobalData();

  const [apps, setApps] = useState([]);
  const options = [
    {
      icon: "fas fa-list",
      value: "List",
    },
    {
      icon: "fas fa-grip-horizontal",
      value: "Grid Medium Square",
    },
    {
      icon: "fas fa-th",
      value: "Grid Large Square",
    },
  ];

  useEffect(() => {
    getAppSystemData();
    window.addEventListener("scroll", listenToScroll);
  }, [reload]);

  const justifyTemplate = (option) => {
    return (
      <React.Fragment>
        <BootstrapTooltip
          title={
            option.value === "Grid Large Square"
              ? "Grid Large Square Layout"
              : option.value === "Grid Medium Square"
              ? "Grid Medium Square Layout"
              : option.value === "List"
              ? "List Layout"
              : null
          }
        >
          <div className="mx-0">
            <i className={option.icon}></i>
          </div>
        </BootstrapTooltip>
      </React.Fragment>
    );
  };

  async function getAppSystemData() {
    const response = await getAppSystem();
    setApps(response.data);
  }

  const listenToScroll = () => {
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;

    const height =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;

    const scrolled = winScroll / height;

    window.scrollTo(window.pageXOffset, window.pageYOffset);
  };

  return (
    <React.Fragment>
      <PageSubHeader
        title="Menu"
        breadcrumbs={[]}
        actionButtons={[]}
        actionGroupButtons={[]}
      />
      <div className="layout-options">
        <SelectButton
          unselectable={false}
          value={userPreferences.menuLayout}
          options={options}
          onChange={(e) => {
            saveUserPreferences({
              ID: userPreferences.ID,
              userID: userPreferences.userID,
              lightAsideSkin: userPreferences.lightAsideSkin,
              darkAsideSkin: userPreferences.darkAsideSkin,
              lightText: userPreferences.lightText,
              darkText: userPreferences.darkText,
              invifoThemeID: userPreferences.invifoThemeID,
              customThemeID: userPreferences.customThemeID,
              language: userPreferences.language,
              menuLayout: e.value,
            }).then((response) => {
              setReload(reload + 1);
            });
          }}
          itemTemplate={justifyTemplate}
        />
      </div>
      {userPreferences.menuLayout === "Grid Large Square" ? (
        <React.Fragment>
          {apps && apps.length > 0
            ? apps.map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    <div className="row menu-row-modules">
                      {item.appSystem && item.appSystem.length > 0 ? (
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <div
                            className={`menu-modules${
                              userPreferences.lightText === true
                                ? " border-white"
                                : ""
                            }`}
                          >
                            <span
                              className={`module-title${
                                userPreferences.lightText === true
                                  ? " text-white"
                                  : ""
                              }`}
                            >
                              {item.module} <i className={item.moduleIcon}></i>
                            </span>
                          </div>
                        </div>
                      ) : null}
                      {item.appSystem && item.appSystem.length > 0
                        ? item.appSystem.map((itemMenu, indexMenu) => {
                            return (
                              <div
                                className="col-sm-6 col-md-6 col-lg-3"
                                key={indexMenu}
                              >
                                <div className="menu-grid-large-square">
                                  <Card
                                    onClick={() => {
                                      history.push(itemMenu.appRoute);
                                    }}
                                    className="h-100"
                                  >
                                    <CardActionArea>
                                      <CardContent>
                                        <div className="menu-title">
                                          {itemMenu.appDesc}
                                        </div>
                                        <Image
                                          src={
                                            process.env.PUBLIC_URL +
                                            `/invifo/icons/${itemMenu.appIcon}`
                                          }
                                          style={{
                                            width: 80,
                                            height: 80,
                                          }}
                                          className="img-fluid"
                                          alt="Tile Menu"
                                        />
                                      </CardContent>
                                    </CardActionArea>
                                  </Card>
                                </div>
                              </div>
                            );
                          })
                        : null}
                    </div>
                  </React.Fragment>
                );
              })
            : null}
        </React.Fragment>
      ) : userPreferences.menuLayout === "Grid Medium Square" ? (
        <React.Fragment>
          {apps && apps.length > 0
            ? apps.map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    <div className="row menu-row-modules">
                      {item.appSystem && item.appSystem.length > 0 ? (
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <div
                            className={`menu-modules${
                              userPreferences.lightText === true
                                ? " border-white"
                                : ""
                            }`}
                          >
                            <span
                              className={`module-title${
                                userPreferences.lightText === true
                                  ? " text-white"
                                  : ""
                              }`}
                            >
                              {item.module} <i className={item.moduleIcon}></i>
                            </span>
                          </div>
                        </div>
                      ) : null}
                      {item.appSystem && item.appSystem.length > 0
                        ? item.appSystem.map((itemMenu, indexMenu) => {
                            return (
                              <div
                                className="col-sm-6 col-md-6 col-lg-3"
                                key={indexMenu}
                              >
                                <div className="menu-grid-medium-square">
                                  <Card
                                    onClick={() => {
                                      history.push(itemMenu.appRoute);
                                    }}
                                    className="h-100"
                                  >
                                    <CardActionArea>
                                      <CardContent>
                                        <div className="menu-img">
                                          <Image
                                            src={
                                              process.env.PUBLIC_URL +
                                              `/invifo/icons/${itemMenu.appIcon}`
                                            }
                                            style={{
                                              maxWidth: 40,
                                              maxHeight: 40,
                                            }}
                                            className="img-fluid float-right my-3 ml-1"
                                            alt="Tile Menu"
                                          />
                                        </div>
                                        <div>
                                          <div className="menu-title">
                                            {itemMenu.appDesc}
                                          </div>
                                          <Typography variant="subtitle1">
                                            {itemMenu.appCode === "LEAD"
                                              ? "Manage potential customer to grow company market"
                                              : itemMenu.appCode === "SLCL"
                                              ? "Collaborate with the team to handle sales life cycle"
                                              : itemMenu.appCode === "SLJO"
                                              ? "Track salesman activity during approaching customer"
                                              : itemMenu.appCode === "CRRPT"
                                              ? "Explore dashboard and various reports of CRM module"
                                              : itemMenu.appCode === "CUST"
                                              ? "Manage customer master data for good quality service"
                                              : itemMenu.appCode === "OUTL"
                                              ? "Manage outlet master data to simplify daily operational"
                                              : itemMenu.appCode === "QUOT"
                                              ? "Publish the price quotation to potential customer"
                                              : itemMenu.appCode === "SORD"
                                              ? "Create the sales document based on order from customer"
                                              : itemMenu.appCode === "ITPR"
                                              ? "Set the default of product selling price as a base price"
                                              : itemMenu.appCode === "ITPC"
                                              ? "Combine some products into single package for special event"
                                              : itemMenu.appCode === "DSPR"
                                              ? "Apply discount on specific product during special event"
                                              : itemMenu.appCode === "POSL"
                                              ? "Sell the product in retail way using Point of Sale (B2C)"
                                              : itemMenu.appCode === "OLSP"
                                              ? "Strengthen the company market using Online Shop"
                                              : itemMenu.appCode === "LICE"
                                              ? "Centralized management of all Global Customer licenses"
                                              : itemMenu.appCode === "SARPT"
                                              ? "Explore dashboard and various reports of Sales module"
                                              : itemMenu.appCode === "WARE"
                                              ? "Manage warehouse master data to simplify daily operational"
                                              : itemMenu.appCode === "ITEM"
                                              ? "Manage product master data to simplify stock opname"
                                              : itemMenu.appCode === "STMG"
                                              ? "Organize all the stock received and issued"
                                              : itemMenu.appCode === "OPLC"
                                              ? "Collaborate with the team to process orders"
                                              : itemMenu.appCode === "INRPT"
                                              ? "Explore dashboard and various reports of Inventory module"
                                              : itemMenu.appCode === "VEND"
                                              ? "Manage vendor master data for good quality service"
                                              : itemMenu.appCode === "PORQ"
                                              ? "Request material purchase to achieve effective supply chain"
                                              : itemMenu.appCode === "PRFQ"
                                              ? "Conduct bidding to get best offer from vendor"
                                              : itemMenu.appCode === "PCOT"
                                              ? "Create an umbrella contract for vendor long-term agreement"
                                              : itemMenu.appCode === "PORD"
                                              ? "Make the purchase document based on company needs"
                                              : itemMenu.appCode === "PRRPT"
                                              ? "Explore dashboard and various reports of Procurement module"
                                              : itemMenu.appCode === "PLNT"
                                              ? "Manage plant master data to optimize daily production"
                                              : itemMenu.appCode === "PROD"
                                              ? "Make the production document to fulfill customer needs"
                                              : itemMenu.appCode === "PDRPT"
                                              ? "Explore dashboard and various reports of Production module"
                                              : itemMenu.appCode === "JRNL"
                                              ? "Perform manual journal entry or check auto-generated journal"
                                              : itemMenu.appCode === "INVO"
                                              ? "Manage A/R and A/P invoice to be more professional"
                                              : itemMenu.appCode === "PAYM"
                                              ? "Manage A/R and A/P payment to be more professional"
                                              : itemMenu.appCode === "ASST"
                                              ? "Digitize the company assets and check the depreciation"
                                              : itemMenu.appCode === "OCPR"
                                              ? "Perform accounting fiscal period month-end closing process"
                                              : itemMenu.appCode === "EXRT"
                                              ? "Setup the exchange currency rates to base currency"
                                              : itemMenu.appCode === "FIRPT"
                                              ? "Explore dashboard and various reports of Finance module"
                                              : itemMenu.appCode === "USER"
                                              ? "Manage user master data and assign the authorization"
                                              : itemMenu.appCode === "USRG"
                                              ? "Manage user group master data for every roles in company"
                                              : itemMenu.appCode === "AUTH"
                                              ? "Manage authorization master data for access of every roles"
                                              : itemMenu.appCode === "USRPT"
                                              ? "Explore dashboard and various reports of User module"
                                              : null}
                                          </Typography>
                                        </div>
                                      </CardContent>
                                    </CardActionArea>
                                  </Card>
                                </div>
                              </div>
                            );
                          })
                        : null}
                    </div>
                  </React.Fragment>
                );
              })
            : null}
        </React.Fragment>
      ) : userPreferences.menuLayout === "List" ? (
        <React.Fragment>
          {apps && apps.length > 0
            ? apps.map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    <div className="row menu-row-modules">
                      {item.appSystem && item.appSystem.length > 0 ? (
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <div
                            className={`menu-modules${
                              userPreferences.lightText === true
                                ? " border-white"
                                : ""
                            }`}
                          >
                            <span
                              className={`module-title${
                                userPreferences.lightText === true
                                  ? " text-white"
                                  : ""
                              }`}
                            >
                              {item.module} <i className={item.moduleIcon}></i>
                            </span>
                          </div>
                        </div>
                      ) : null}
                      {item.appSystem && item.appSystem.length > 0
                        ? item.appSystem.map((itemMenu, indexMenu) => {
                            return (
                              <div
                                className="col-sm-12 col-md-12 col-lg-12"
                                key={indexMenu}
                              >
                                <div className="menu-list">
                                  <Card
                                    className="menu-card"
                                    onClick={() => {
                                      history.push(itemMenu.appRoute);
                                    }}
                                  >
                                    <CardActionArea>
                                      <CardContent className="menu-content">
                                        <Image
                                          src={
                                            process.env.PUBLIC_URL +
                                            `/invifo/icons/${itemMenu.appIcon}`
                                          }
                                          style={{
                                            width: 30,
                                            height: 30,
                                          }}
                                          className="img-fluid"
                                          alt="Tile Menu"
                                        />
                                        <span className="menu-title">
                                          {itemMenu.appDesc}
                                        </span>
                                      </CardContent>
                                    </CardActionArea>
                                  </Card>
                                </div>
                              </div>
                            );
                          })
                        : null}
                    </div>
                  </React.Fragment>
                );
              })
            : null}
        </React.Fragment>
      ) : null}
    </React.Fragment>
  );
}
export default connect(null, auth.actions)(Menu);
